export enum GtmItemCategory {
    Mtpl = 'mtpl',
    Casco = 'casco',
    CascoMtpl = 'casco_mtpl',
    Rider = 'rider',
    TransportInsurance = 'transport_insurance',
    TravelMedicalExpenses = 'travel_medical_expenses',
    TravelAccident = 'travel_accident',
    TravelBaggage = 'travel_baggage',
    TravelCivilResponsibility = 'travel_civil_responsibility',
    TravelInsurance = 'travel_insurance',
    PersonalAccidentsInsurance = 'personal_accidents_insurance',
    HomeInsurance = 'home_insurance',
}
